import { FieldArrayRenderProps } from "formik";

export interface AiAgentMcpServerItem {
    id: string;           // temp React key
    mcpServerId: string;  // actual server ID
}

export const addMcpServer = (arrayHelpers: FieldArrayRenderProps) => {
    const newServer: AiAgentMcpServerItem = {
        id: crypto.randomUUID(),
        mcpServerId: "",
    };
    arrayHelpers.push(newServer);
};
